import { render, staticRenderFns } from "./AreaBottom.vue?vue&type=template&id=a373a3d0"
import script from "./AreaBottom.vue?vue&type=script&lang=ts"
export * from "./AreaBottom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports